import { Inject, Injectable, InjectionToken, ValueProvider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Segment, SEGMENT_DEFAULT } from '../service.constant';
import { CookieService } from 'ngx-cookie-service';

export interface AudienceManagerServiceConfig {
  segments: Segment[];
  audienceManagerUrlTemplate: string;
}

export const AUDIENCE_MANAGER_SERVICE_CONFIG = new InjectionToken<AudienceManagerServiceConfig>(
  'AudienceManagerServiceConfig',
);

@Injectable()
export class AudienceManagerService {
  constructor(
    @Inject(AUDIENCE_MANAGER_SERVICE_CONFIG) private config: AudienceManagerServiceConfig,
    private httpClient: HttpClient,
    private cookieService: CookieService,
  ) {}

  static configure(config?: AudienceManagerServiceConfig): ValueProvider {
    return {
      provide: AUDIENCE_MANAGER_SERVICE_CONFIG,
      useValue: config || {},
    };
  }

  getSegmentByCookie$(): Observable<string> {
    const segmentPriorityMap = this.config.segments;
    const flatSegs = segmentPriorityMap.map((seg: any) => seg.id);
    const uuidCookie = this.cookieService.get('aam_uuid') || '1';
    const apiUrl = this.config.audienceManagerUrlTemplate.replace('{{uuid}}', uuidCookie);

    return this.httpClient.get(apiUrl, { observe: 'response' }).pipe(
      map(response => {
        const stuff = response.body['stuff'];
        if (!stuff) {
          return SEGMENT_DEFAULT;
        }
        const segmentIdsFromApi: string[] = stuff
          .find(item => item['cn'] === 'at_rogerscommunicaitonp')
          ['cv'].slice(9)
          .split(',');
        const filteredSegmentIds = segmentIdsFromApi.filter(item => flatSegs.includes(item));
        if (filteredSegmentIds.length > 0) {
          const prioritySegId = filteredSegmentIds.reduce((highestPriority, currentSeg) =>
            flatSegs.indexOf(currentSeg) < flatSegs.indexOf(highestPriority) ? currentSeg : highestPriority,
          );
          return (segmentPriorityMap[flatSegs.indexOf(prioritySegId)] as any).segment;
        }
        return SEGMENT_DEFAULT;
      }),
      catchError(() => of(SEGMENT_DEFAULT)),
    );
  }
}
